// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1qp2J","buttons":"RemoveExpirationActionButtons_buttons__1CSAK"};